import { createAsyncThunk } from '@reduxjs/toolkit'
import { megaMenuAPI } from 'src/api/mega-menu'
import { IUpdateMegaMenuValue } from 'src/interfaces/mega-menu'

export const getListMegaMenu = createAsyncThunk(
  'megaMenu/getListMegaMenu',
  async (_, { rejectWithValue }) => {
    try {
      const response = await megaMenuAPI.getListMegaMenu()
      return response
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const updateMegaMenu = createAsyncThunk(
  'megaMenu/updateMegaMenu',
  async (
    { id, data }: { id: number; data: IUpdateMegaMenuValue },
    { rejectWithValue }
  ) => {
    try {
      const response = await megaMenuAPI.updateMegaMenu(id, data)
      return { id, data: response }
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)
